import React from 'react';
import PaginationComponent from "../../../component/table/Pagination";
import * as apiUtils from "../../../util/apiUtil";

import * as announceAction from "../store/announce";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link} from "@mui/material";
import Loading from "../../../component/loading/Loading";

class AnnounceListContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        /*페이지 handleing*/
        this.handlePageChange = this.handlePageChange.bind(this);
        /*리스트 받아오기*/
        this.ajaxAnnounceList = this.ajaxAnnounceList.bind(this);

        this.state = {
            loading: false,
        }
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.announceList !== nextProps.announceList
            || this.props.page !== nextProps.page
            || this.props.total !== nextProps.total
        )
    }//end shouldCompUpdate

    componentDidMount() {
        this.ajaxAnnounceList();
    }// end compDidMOunt

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    async handlePageChange(event, value) {
        const { AnnounceAction } = this.props;
        await AnnounceAction.setPage(value);

        this.ajaxAnnounceList();
    }// end handlePageChange

    ajaxAnnounceList() {
        const { page, size, AnnounceAction } = this.props;
        apiUtils.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/notice/list",
            method: apiUtils.requestMethod.POST,
            data: {
                page: page,
                size: size
            },
            success: (result) => {
                AnnounceAction.setTotal(result.total);
                AnnounceAction.setAnnounceList(result.content);
            }
        });
    }// end ajaxAnnounceList


    render() {
        const { loading } = this.state;
        const { announceList, total, size, page } = this.props;
        const { handlePageChange } = this;
        return (
            <>
                <Loading loading={loading}/>
                <section className='container-xxl announce-list'>
                    <h2 className='fs-4'>공지사항</h2>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='table-responsive'>
                                <table className="table table-hover">
                                    <thead className='table-primary'>
                                        <tr>
                                            <th>번호</th>
                                            <th>제목</th>
                                            <th>첨부</th>
                                            <th>등록일</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {announceList.length !== 0
                                            ? announceList.map((message, idx) => (
                                                <tr key={idx}>
                                                    <td>{10 * (page - 1) + idx + 1}</td>
                                                    <td><Link href={"/announce/detail/" + message.uid}>{message.title}</Link></td>
                                                    <td className="text-center">{message.fileJson != null ? <span className="material-symbols-rounded fs-7">attach_file</span> : ""}</td>
                                                    <td>{message.createdAt}</td>
                                                </tr> ))
                                            :   <tr>
                                                    <td colSpan={4}>No Data</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                                <PaginationComponent handleChange={handlePageChange} sizePerPage={size} total={total} />
                            </div>
                        </div>
                    </div>
                </section>

    </>
    )
    }// end render
}// end class

export default connect((state) => ({
        announceList: state.announce.announceList,
        total: state.announce.total,
        size: state.announce.size,
        page: state.announce.page
    }),
(dispatch) => ({
    AnnounceAction: bindActionCreators(announceAction, dispatch)
})
)(AnnounceListContainer);
